import { render, staticRenderFns } from "./MapDetailsNanogenres.vue?vue&type=template&id=02ec318d&scoped=true&"
import script from "./MapDetailsNanogenres.vue?vue&type=script&lang=js&"
export * from "./MapDetailsNanogenres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ec318d",
  null
  
)

export default component.exports